import { Decimals } from '@/src/lib/SmartDB/Commons/types';

//----------------------------------------------------------------------

export const isWebsiteGovernance = process.env.NEXT_PUBLIC_WEBSITE === 'Governance';
export const isWebsiteDApp = process.env.NEXT_PUBLIC_WEBSITE === 'DApp';

export const showDappHeaderButton = process.env.NEXT_PUBLIC_SHOW_DAPP_HEADER_BUTTON !== undefined ? process.env.NEXT_PUBLIC_SHOW_DAPP_HEADER_BUTTON === 'true' : false;

export const showADAPriceToggleButton = process.env.NEXT_PUBLIC_SHOW_ADAPRICE_TOGGLE_BUTTON !== undefined ? process.env.NEXT_PUBLIC_SHOW_ADAPRICE_TOGGLE_BUTTON === 'true' : false;

//----------------------------------------------------------------------

export const MAYZ_WALLET_CONTROL_STAKE_DELEGATION = process.env.NEXT_PUBLIC_MAYZ_WALLET_CONTROL_STAKE_DELEGATION ?? '';

//------------------------------------------
// SWAP OFFERS

export const SWAPS_REFRESH_TIME_MS = 60 * 1000; // 1 minute

//------------------------------------------
// HISTORY

export const MAX_DAYS_TO_INTERPOLATE = 5;

//----------------------------------------------------------------------
//SEO AND SOCIAL MEDIA

export const WEBSITE_NAME = isWebsiteGovernance ? 'MAYZ Gov Protocol' : 'MAYZ Protocol';
export const WEBSITE_TITLE = isWebsiteGovernance
    ? `MAYZ | Governance Portal | ${process.env.NEXT_PUBLIC_CARDANO_NET} Network`
    : `MAYZ | Index Funds Portal | ${process.env.NEXT_PUBLIC_CARDANO_NET} Network`;
export const WEBSITE_DESC = isWebsiteGovernance
    ? 'Decentralized Finance Protocol - Crooss-Chain platform - mayz.io'
    : 'Decentralized Finance Protocol - Crooss-Chain platform - mayz.io';
export const WEBSITE_TAGS = isWebsiteGovernance
    ? 'MAYZ, Decentralized Finance, Protocol, Governance, Crooss-Chain, mayz.io'
    : 'MAYZ, Decentralized Finance, Protocol, Crooss-Chain, mayz.io';
export const WEBSITE_LINK_TO_MAIN_PAGE = isWebsiteGovernance ? 'https://mayz.io' : 'https://mayz.io';
export const WEBSITE_URL_LOGO = isWebsiteGovernance
    ? 'https://mayz.io/_next/image?url=%2Fimg%2Flogo%2Fpose_7-min.png&w=640&q=75'
    : 'https://mayz.io/_next/image?url=%2Fimg%2Flogo%2Fpose_7-min.png&w=640&q=75';

//----------------------------------------------------------------------
// SMART CONTRACT VERSIONING

const PROTOCOL_BASE_VERSION = 4;
const FUND_BASE_VERSION = 4;
const SWAPOFFER_BASE_VERSION = 1;
const DELEGATION_BASE_VERSION = 1;
const SCRIPT_BASE_VERSION = 1;

export function mkVersionWithDependency(xs: number[], ownVersion: number): number {
    return xs.reduceRight((acc, x) => acc * 100 + x, ownVersion);
}

export const PROTOCOL_VERSION = mkVersionWithDependency([], PROTOCOL_BASE_VERSION);
export const FUND_VERSION = mkVersionWithDependency([PROTOCOL_BASE_VERSION], FUND_BASE_VERSION);
export const INVESTUNI_TVERSION = mkVersionWithDependency([PROTOCOL_BASE_VERSION], FUND_BASE_VERSION);
export const FUNDHOLDING_VERSION = mkVersionWithDependency([PROTOCOL_BASE_VERSION], FUND_BASE_VERSION);
export const SWAPOFFER_VERSION = mkVersionWithDependency([PROTOCOL_BASE_VERSION, FUND_BASE_VERSION], SWAPOFFER_BASE_VERSION);
export const DELEGATION_VERSION = mkVersionWithDependency([PROTOCOL_BASE_VERSION, FUND_BASE_VERSION], DELEGATION_BASE_VERSION);
export const SCRIPT_VERSION = mkVersionWithDependency([PROTOCOL_BASE_VERSION, FUND_BASE_VERSION], SCRIPT_BASE_VERSION);

//----------------------------------------------------------------------

export const TRANSACTION_UNKNOWN = 'Unknown';

export const PROTOCOL_DEPLOY = 'Protocol - Deploy';
export const PROTOCOL_UPDATE = 'Protocol - Update';
export const PROTOCOL_UPDATE_MIN_ADA = 'Protocol - Update Locked ADA';
export const PROTOCOL_EMERGENCY = 'Protocol - Emergency';

export const FUND_DEPLOY = 'Fund - Deploy';
export const FUND_UPDATE = 'Fund - Update';
export const FUND_UPDATE_MIN_ADA = 'Fund - Update Locked ADA';
export const FUND_ADD_FUNDHOLDING = 'Fund - Add Fund Holding';
export const FUND_DELETE_FUNDHOLDING = 'Fund - Delete Fund Holding';
export const FUND_EMERGENCY = 'Fund - Emergency';
export const FUND_FINISH = 'Fund - Finish';
export const FUND_DELETE = 'Fund - Delete';

export const FUND_DEPOSIT = 'Fund - Deposit';
export const FUND_WITHDRAW = 'Fund - Withdraw';
export const FUND_REINDEXING = 'Fund - ReIndexing';

export const FUND_COLLECT_PROTOCOL_COMMISSIONS = 'Fund - Collect Protocol Commissions';
export const FUND_COLLECT_MANAGERS_COMMISSIONS = 'Fund - Collect Managers Commissions';
export const FUND_COLLECT_DELEGATORS_COMMISSIONS = 'Fund - Collect Delegators Commissions';

export const FUNDHOLDING_UPDATE_MIN_ADA = 'Fund Holding - Update Locked ADA';
export const FUNDHOLDING_BALANCE_ASSETS = 'Fund Holding - Balance Assets';
export const FUNDHOLDING_EMERGENCY = 'Fund Holding - Emergency';
export const FUNDHOLDING_DELETE = 'Fund Holding - Delete';

export const DELEGATION_CREATE = 'Delegation - Create';
export const DELEGATION_DEPOSIT = 'Delegation - Deposit';
export const DELEGATION_WITHDRAW = 'Delegation - Withdraw';
export const DELEGATION_UPDATE_MIN_ADA = 'Delegation - Update Locked ADA';
export const DELEGATION_DELETE = 'Delegation - Delete';

export const SCRIPTS_ADD_FOR_PROTOCOL = 'Scripts - Add for Protocol';
export const SCRIPTS_ADD_FOR_FUND = 'Scripts - Add for Fund';
export const SCRIPT_DELETE = 'Scripts - Delete';

export const SWAPOFFER_CREATE = 'Swap Offer - Create';
export const SWAPOFFER_SWAP_ADA_FT = 'Swap Offer - Buy FT';
export const SWAPOFFER_SWAP_FT_ADA = 'Swap Offer - Sell FT';
export const SWAPOFFER_DEPOSIT = 'Swap Offer - Deposit';
export const SWAPOFFER_WITHDRAW = 'Swap Offer - Withdraw';
export const SWAPOFFER_UPDATE_MIN_ADA = 'Swap Offer - Update Locked ADA';
export const SWAPOFFER_UPDATE_STATUS = 'Swap Offer - Update Status';
export const SWAPOFFER_UPDATE_COMMISSIONS = 'Swap Offer - Update Commissions';
export const SWAPOFFER_UPDATE_SWAP_RESTRICTIONS = 'Swap Offer - Update Swap Restrictions';
export const SWAPOFFER_DELETE = 'Swap Offer - Delete';

//----------------------------------------------------------------------

export const FUND_STATUS_NOT_DEPLOYED = 'Not Deployed';
export const FUND_STATUS_NOT_STARTED = 'Not Started';
export const FUND_STATUS_NO_FUND_HOLDINGS = 'No Fund Holdings';
export const FUND_STATUS_READY = 'Ready';
export const FUND_STATUS_CLOSED = 'Closed';

//----------------------------------------------------------------------

export const STATUS_OPEN = 1;
export const STATUS_CLOSED = 2;
export const STATUS_STRINGS = ['Open', 'Closed'];

export const STATUS_ALLOW_SELL = 1;
export const STATUS_NOT_ALLOW_SELL = 2;
export const STATUS_ALLOW_SELL_STRINGS = ['Allow', 'Not Allow'];

//----------------------------------------------------------------------
// TOKENS

export const EMERGENCY_ADMIN_TOKEN_CS = process.env.NEXT_PUBLIC_EMERGENCY_ADMIN_TOKEN_POLICY_CS!;
export const EMERGENCY_ADMIN_TOKEN_TN_STR = 'EMRCY';
export const ADMIN_TOKEN_CS = process.env.NEXT_PUBLIC_ADMIN_TOKEN_POLICY_CS!;
export const ADMIN_TOKEN_TN_STR = 'ADMIN';

export const TOKEN_GOV_CS = process.env.NEXT_PUBLIC_TOKEN_GOV_POLICY_CS!;
export const TOKEN_GOV_TN_STR = process.env.NEXT_PUBLIC_TOKEN_GOV_NAME_STR!;
export const TOKEN_GOV_TICKER = process.env.NEXT_PUBLIC_TOKEN_GOV_NAME_STR!;

export const TOKEN_GOV_DECIMALS: Decimals = 6;
export const TOKEN_FT_DECIMALS: Decimals = 6;
export const TOKEN_LP_DECIMALS: Decimals = 6;
export const TOKEN_LIQWID_DECIMALS: Decimals = 6;

export const PROTOCOL_ID_TN_STR = 'ProtocolID';
export const FUND_ID_TN_STR = 'FundID';
export const INVESTUNIT_ID_TN_STR = 'IUID';
export const FUNDHOLDING_ID_TN_STR_basename = 'FundHoldingID';
export const SWAPOFFER_ID_TN_STR = 'SwapOfferID';
export const BUYORDER_ID_TN_STR = 'BuyOrderID';
export const DELEGATION_ID_TN_STR = 'DelegationID';

export const PROTOCOL_ID_TICKER = 'PID';
export const FUND_ID_TICKER = 'FID';
export const INVESTUNIT_ID_TICKER = 'IUID';
export const FUNDHOLDING_ID_TICKER_basename = 'FHID';
export const SWAPOFFER_ID_TICKER = 'SOID';
export const BUYORDER_ID_TICKER = 'BOID';
export const DELEGATION_ID_TICKER = 'DEID';

export const INVESTUNIT_DECIMALS = 2;
export const INVESTUNIT_MULTIPLIER = 100;

export const DEFAULT_MAXDEPOSITANDWITHDRAW = 999_999_999_999_999n;

//----------------------------------------------------------------------

export const DEFAULT_FUND_CATEGORY = { fcCategoryNumber: 0, fcRequiredTokenGov: 100_000_0000n, fcMaxUI: 100_000_000_000n };
//100 TOKEN GOV

export const DEFAULT_FUND_LIFE_TIME = { mmdMin: BigInt(90 * 24 * 60 * 60 * 1000), mmdMax: BigInt(3 * 365 * 24 * 60 * 60 * 1000), mmdDef: BigInt(356 * 24 * 60 * 60 * 1000) };
//min 90 dias, max 3 años, def 356 dias

export const DEFAULT_REQUIRED_TOKEN_GOV_FOR_SWAPOFFER = 10_000_0000n;

export const DEFAULT_REQUIRED_TOKEN_GOV_FOR_BUYORDER = 10_000_0000n;

export const DEFAULT_COMMISSION_FUNDS = { mmdMin: 0, mmdMax: 1_000_000, mmdDef: 120_000 };
// MAX es 12_000_000 Annual = 10% mensual, DEF es 120_000 Annual = 0,1% mensual

export const DEFAULT_COMMISSION_SWAPOFFER = { mmdMin: 0, mmdMax: 500_000, mmdDef: 100_000 };

export const DEFAULT_COMMISSION_BUYORDER = { mmdMin: 0, mmdMax: 500_000, mmdDef: 100_000 };

export const DEFAULT_PROTOCOL_SHARE = 333_333;
export const DEFAULT_MANAGERS_SHARE = 333_334;
export const DEFAULT_DELEGATORS_SHARE = 333_333;

//----------------------------------------------------------------------
// TAKS

export const enum TASK {
    CREATE = 'Create',
    UPDATE = 'Update',
    EDIT = 'Edit',
    DELETE = 'Delete',
    CHARTS = 'Charts',
    DEPLOYTX = 'DeployTx',
    UPDATETX = 'UpdateTx',
    DEPOSITTX = 'DepositTx',
    WITHDRAWTX = 'WithdrawTx',
    UPDATE_MIN_ADA_TX = 'UpdateMinADATx',
    COLLECT_PROTOCOL_COMMISSIONS_TX = 'COLLECT_PROTOCOL_COMMISSIONS_TX',
    COLLECT_MANAGERS_COMMISSIONS_TX = 'COLLECT_MANAGERS_COMMISSIONS_TX',
    COLLECT_DELEGATORS_COMMISSIONS_TX = 'COLLECT_DELEGATORS_COMMISSIONS_TX',
    MINTTX = 'MintTx',
    ADDSCRIPTSTX = 'AddScriptsTx',
    PARSEBLOCKCHAIN = 'ParseBlockchain',
    SITESETTINGS = 'SiteSettings',
    WALLETS = 'Wallets',
    EMULATORS = 'Emulators',
    ADDRESSESTOFOLLOW = 'AddressesToFollow',
    SMARTUTXOS = 'SmartUTxOs',
    PROTOCOLS = 'Protocols',
    PROTOCOL_FUNDFACTORIES = 'FundFactories',
    FUNDS = 'Funds',
    SCRIPTS = 'Scripts',
    FUND_FUNDHOLDINGS = 'FundHoldings',
    FUND_REINDEXINGTX = 'ReIndexingTx',
    FUND_TOKENMETADATA = 'TokenMetadata',
    TOKENSMETADATA = 'TokensMetadata',
    TRANSACTIONS = 'Transactions',
    SWAPOFFERS = 'Swaps',
    SWAPOFFERS_SWAPFTXADATX = 'SwapFTxADATx',
    SWAPOFFERS_SWAPADAXFTTX = 'SwapADAxFTTx',
    SWAPOFFERS_UPDATE_STATUS = 'UpdateStatus',
    SWAPOFFERS_UPDATE_COMMISSION = 'UpdateCommission',
    SWAPOFFERS_UPDATE_RESTRICTIONS = 'UpdateRestrictions',
    BUYORDERS = 'BuyOrders',
    DELEGATIONS = 'Delegations',
    MY_PARTICIPATION = 'MyParticipation',
}

export const enum TASK_QUERY_NAME {
    TASK = 'Task',
    SITESETTINGS = 'SiteSettingsTask',
    WALLETS = 'WalletsTask',
    EMULATORS = 'EmulatorsTask',
    ADDRESSESTOFOLLOW = 'AddressesToFollowTask',
    SMARTUTXOS = 'SmartUtxosTask',
    PROTOCOLS = 'ProtocolsTask',
    FUNDFACTORIES = 'FundFactoriesTask',
    FUNDS = 'FundsTask',
    FUNDHOLDINGS = 'FundHoldingsTask',
    FUNDS_ADMIN = 'FundsAdminTask',
    FUNDS_USER = 'FundsUserTask',
    TOKENSMETADATA = 'TokensMetadataTask',
    TRANSACTIONS = 'TransactionsTask',
    SWAPOFFERS = 'SwapOffersTask',
    BUYORDERS = 'BuyOrdersTask',
    DELEGATIONS = 'DelegationsTask',
    SCRIPTS = 'ScriptsTask',
    MY_PARTICIPATION = 'MyParticipationTask',
}

export const enum TASK_QUERY_ID_NAME {
    SITESETTINGS = 'siteSettingId',
    WALLETS = 'walletId',
    EMULATORS = 'emulatorId',
    ADDRESSESTOFOLLOW = 'addressesToFolloId',
    SMARTUTXOS = 'smartUtxoId',
    PROTOCOLS = 'protocolId',
    FUNDFACTORIES = 'fundFactoryId',
    FUNDS = 'fundId',
    FUNDHOLDINGS = 'fundHoldingId',
    TOKENSMETADATA = 'tokensMetadatId',
    TRANSACTIONS = 'transactionId',
    SWAPOFFERS = 'swapId',
    BUYORDERS = 'buyOrderId',
    SCRIPTS = 'scriptId',
    DELEGATIONS = 'delegationId',
}

export const TAKS_ALLOWED_ADMIN_DASHBOARD = [
    TASK.SITESETTINGS,
    TASK.WALLETS,
    TASK.EMULATORS,
    TASK.ADDRESSESTOFOLLOW,
    TASK.SMARTUTXOS,
    TASK.PROTOCOLS,
    TASK.FUNDS,
    TASK.TOKENSMETADATA,
    TASK.TRANSACTIONS,
    TASK.SWAPOFFERS,
    TASK.BUYORDERS,
    TASK.SCRIPTS,
    TASK.DELEGATIONS,
];

export const TAKS_ALLOWED_PORTFOLIO_DASHBOARD = [TASK.FUNDS, TASK.MY_PARTICIPATION, TASK.TOKENSMETADATA, TASK.TRANSACTIONS, TASK.SWAPOFFERS, TASK.BUYORDERS, TASK.DELEGATIONS];

export const TAKS_ALLOWED_PROTOCOL_DASHBOARD = [
    TASK.UPDATE,
    TASK.DELETE,
    TASK.PROTOCOL_FUNDFACTORIES,
    TASK.DEPLOYTX,
    TASK.UPDATETX,
    TASK.UPDATE_MIN_ADA_TX,
    TASK.ADDSCRIPTSTX,
    TASK.PARSEBLOCKCHAIN,
];

export const TAKS_ALLOWED_FUND_ADMIN_DASHBOARD = [
    TASK.UPDATE,
    TASK.UPDATE_MIN_ADA_TX,
    TASK.DELETE,
    TASK.FUND_FUNDHOLDINGS,
    TASK.DEPLOYTX,
    TASK.UPDATETX,
    TASK.ADDSCRIPTSTX,
    TASK.FUND_REINDEXINGTX,
    TASK.FUND_TOKENMETADATA,
    TASK.PARSEBLOCKCHAIN,
    TASK.CHARTS,
];

export const TAKS_ALLOWED_FUND_USER_DASHBOARD = [
    TASK.DEPOSITTX,
    TASK.WITHDRAWTX,
    TASK.MINTTX,
    TASK.TRANSACTIONS,
    TASK.SWAPOFFERS,
    TASK.SWAPOFFERS_SWAPFTXADATX,
    TASK.SWAPOFFERS_SWAPADAXFTTX,
    TASK.BUYORDERS,
    TASK.DELEGATIONS,
];

export const TAKS_ALLOWED_MY_PARTICIPATION_FUND_DASHBOARD = [TASK.CHARTS];

export const TAKS_ALLOWED_PROTOCOLS = [TASK.CREATE];

export const TAKS_ALLOWED_FUNDFACTORIES = [TASK.CREATE];

export const TAKS_ALLOWED_FUNDS = [TASK.CREATE];

export const TAKS_ALLOWED_MY_PARTICIPATION_FUNDS = [];

export const TAKS_ALLOWED_FUNDHOLDINGS = [
    TASK.CREATE,
    TASK.UPDATE_MIN_ADA_TX,
    TASK.COLLECT_PROTOCOL_COMMISSIONS_TX,
    TASK.COLLECT_MANAGERS_COMMISSIONS_TX,
    TASK.COLLECT_DELEGATORS_COMMISSIONS_TX,
    TASK.DELETE,
];

export const TAKS_ALLOWED_SITESETTINGS = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_WALLETS = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_EMULATORS = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_ADDRESSESTOFOLLOW = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_SMARTUTXOS = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_TOKENSMETADATA = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_TRANSACTIONS = [TASK.PARSEBLOCKCHAIN];

export const TAKS_ALLOWED_SWAPOFFERS = [
    TASK.CREATE,
    TASK.SWAPOFFERS_UPDATE_STATUS,
    TASK.SWAPOFFERS_UPDATE_COMMISSION,
    TASK.SWAPOFFERS_UPDATE_RESTRICTIONS,
    TASK.DEPOSITTX,
    TASK.WITHDRAWTX,
    TASK.UPDATE_MIN_ADA_TX,
    TASK.DELETE,
];

export type TAKS_ALLOWED_SWAPOFFERS_OPTIONS =
    | TASK.CREATE
    | TASK.SWAPOFFERS_UPDATE_STATUS
    | TASK.SWAPOFFERS_UPDATE_COMMISSION
    | TASK.SWAPOFFERS_UPDATE_RESTRICTIONS
    | TASK.DEPOSITTX
    | TASK.WITHDRAWTX
    | TASK.UPDATE_MIN_ADA_TX
    | TASK.DELETE;

export const TAKS_ALLOWED_BUYORDERS = [TASK.CREATE, TASK.UPDATE, TASK.DELETE];

export const TAKS_ALLOWED_DELEGATIONS = [TASK.CREATE, TASK.DEPOSITTX, TASK.WITHDRAWTX, TASK.UPDATE_MIN_ADA_TX];

export const TAKS_ALLOWED_SCRIPTS = [TASK.DELETE, TASK.UPDATE_MIN_ADA_TX];

// ------------------------------------------
// ADA PRICE
export const ADA_PRICE_ENDPOINT = process.env.NEXT_PUBLIC_ADA_PRICE_ENDPOINT ?? 'prices/get-ada-usd-price';
export const ADA_HISTORIC_PRICE_ENDPOINT = process.env.NEXT_PUBLIC_ADA_HISTORIC_PRICE_ENDPOINT ?? 'prices-historic/get-ada-usd-historic-price';

export const COINGEKO_API_KEY = process.env.COINGEKO_API_KEY ?? '';
export const COINGECKO_API_URL = process.env.COINGEKO_API_URL ?? 'https://api.coingecko.com/api/v3';
export const COINGECKO_ADA_PRICE_URL = process.env.COINGECKO_ADA_PRICE_URL ?? `${COINGECKO_API_URL}/simple/price?ids=cardano&vs_currencies=usd`;
export const COINGECKO_ADA_HISTORIC_PRICE_URL = process.env.COINGECKO_ADA_HISTORIC_PRICE_URL ?? `${COINGECKO_API_URL}/coins/cardano/history`;

